import { MainLayout } from '../style/Layout';
import React from 'react';
import Resume from '../Components/Resume';
import Skills from '../Components/Skills';
import styled from 'styled-components';

function ResumePage() {
    return (
        <MainLayout>
            <ResumePageStyled>
                <Skills />
                <Resume/>
                {/* <InnerLayout>
                </InnerLayout> */}
            </ResumePageStyled>
        </MainLayout>
    )
}

const ResumePageStyled = styled.div`

`;

export default ResumePage;
